module.exports = __webpack_public_path__ + "img/12angry-8.005f5b20.jpg";